<template>
  <div v-if="isVisible" class="add-to-home-screen" @click="handleClick">
    <!-- Chrome 浏览器提示 -->
    <div v-if="isChrome" class="content-wrapper chrome-position" ref="contentWrapper">
      <div class="Chrome_arrow-container">
        <div class="Chrome_arrow-up"></div>
      </div>
      <div class="content-container chrome-container">
        <img src="@/assets/img/product_icon.png" alt="Logo" class="logo" />
        <div class="instructions">
          <p class="instructions_title">Hanya 2 langkah yang diperlukan</p>
          <p>
            <span><span class="number">1:</span>Klik tombol ini </span>
            <img class="icon-placeholder" src="@/assets/img/Chrome_Share.png" alt="">
            <span><span class="number">2:</span>Gulir ke atas untuk menemukan "Tambah ke Layar
              Utama" dan ketuk</span>
            <img class="screenshot-icon" src="@/assets/img/screenshot.png">
            <span> <span class="number">3:</span>Klik "Tambah"</span>
          </p>

        </div>
      </div>
    </div>

    <!-- Safari 浏览器提示 -->
    <div v-if="isSafari" class="content-wrapper" ref="contentWrapper">
      <div class="content-container">
        <img src="@/assets/img/product_icon.png" alt="Logo" class="logo" />
        <div class="instructions">
          <p class="instructions_title">Hanya 2 langkah yang diperlukan</p>
          <p>
            <span><span class="number">1:</span>Klik tombol ini </span>
            <img class="icon-placeholder" src="@/assets/img/iOS_Share.png" alt="">
            <span><span class="number">2:</span>Gulir ke atas untuk menemukan "Tambah ke Layar
              Utama" dan ketuk</span>
            <img class="screenshot-icon" src="@/assets/img/screenshot.png">
            <span> <span class="number">3:</span>Klik "Tambah"</span>
          </p>
        </div>
      </div>
      <div class="arrow-container ">
        <div class="arrow-down"></div>
      </div>
    </div>

    <!--提示下载app或者将网站添加到桌面 -->
    <div v-if="showTipsPopup" class="tips-popup">
      <div class="tips-content">
        <div class="tips-header">
          <h2>Peringatan Penting</h2>
        </div>
        <div class="tips-body">
          <p>
            Setelah memasang saya di layar utama, kamu bisa mendapatkan jumlah pinjaman yang lebih tinggi, bunga yang
            menurun, dan manfaat lainnya. Ini nantinya akan memudahkan kamu untuk menemukan saya.
          </p>

          <div class="method-container">
            <!-- 已完成 -->
            <button class="unfinished" @click.stop="closeTipsPopup">Sudah Terpasang</button>
            <!-- 去完成 -->
            <button class="completed" @click.stop="handleMethod1">Pasang Sekarang</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isVisible: false,
      animationStarted: false,
      isChrome: false,
      isSafari: false,
      animationEnded: false,
      showTipsPopup: true // 默认显示新的提示弹框
    }
  },
  methods: {
    // 点击蒙版
    handleClick () {
      // 只有当动画结束后才能关闭弹框
      if (this.animationEnded) {
        this.hidePrompt()
      }
    },
    // 关闭弹框
    hidePrompt () {
      // 添加淡出效果
      this.$el.classList.add('fade-out')
      setTimeout(() => {
        this.isVisible = false
      }, 500)
    },
    // 关闭提示弹框
    closeTipsPopup () {
      localStorage.setItem('addToHomeScreenPromptShown', 'true')
      this.showTipsPopup = false
      this.isVisible = false
    },

    // 处理方法1
    handleMethod1 () {
      this.showTipsPopup = false
      this.checkIfShouldShow()
    },
    // 检测浏览器环境
    detectBrowser () {
      const userAgent = navigator.userAgent
      // 更精确地检测是否是Chrome浏览器
      if (
        userAgent.includes('CriOS') || // iOS上的Chrome
        (userAgent.includes('Chrome') && !userAgent.includes('Edg')) || // 排除Edge
        (/Android/i.test(userAgent) && /Chrome\/[.0-9]*/.test(userAgent)) // Android上的Chrome
      ) {
        this.isChrome = true
        this.isSafari = false
      } else if (
        // 检测是否是Safari
        (userAgent.includes('Safari') && !userAgent.includes('Chrome')) ||
        (/iPhone|iPad|iPod/i.test(userAgent) && !userAgent.includes('CriOS'))
      ) {
        this.isChrome = false
        this.isSafari = true
      } else {
        // 其他浏览器
        this.isChrome = false
        this.isSafari = false
        console.log('other browser')
      }
    },
    // 是否显示
    checkIfShouldShow () {
      this.detectBrowser()
      if (this.isSafari || this.isChrome) {
        setTimeout(() => {
          this.animationStarted = true
          setTimeout(() => {
            this.animationEnded = true
          }, 1500) // 将动画时间改为 1.2s
        }, 1000)
      }
    }
  },
  mounted () {
    // 从链接进入的才会显示弹框
    const source = localStorage.getItem('source')
    if (source === 'link') {
      // 检查是否显示提示
      const hasShown = localStorage.getItem('addToHomeScreenPromptShown')
      if (!hasShown) {
        this.isVisible = true
      }
    }
  }
}
</script>

<style scoped lang="less">
.add-to-home-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  color: white;
  padding: 20px;
  overflow: hidden;
  transition: opacity 0.5s ease;
}

.fade-out {
  opacity: 0;
}

.content-wrapper {
  animation: slideDown 1.5s cubic-bezier(0.33, 1, 0.68, 1) forwards;
  transform: translateY(-100%);
  display: flex;
  flex-direction: column;
  align-items: center;

  &.chrome-position {
    position: absolute;
    right: 20px;
    top: 0;
    transform: translateY(-100%);
    animation: chromeSlideDown 2.5s cubic-bezier(0.215, 0.610, 0.355, 1.000) forwards;
  }
}

.content-container {
  position: relative;
  width: 550px;
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  color: #333;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.logo {
  width: 100px;
  height: auto;
  margin: 0 auto 20px;
  display: block;
}

.instructions {
  font-size: 24px;
  line-height: 1.5;
  margin-bottom: 20px;

  p {
    display: flex;
    flex-wrap: wrap;
  }

  .number {
    color: #000;
    font-weight: bold;
    margin-right: 10px;
  }
}

.instructions_title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 10px;
}

.screenshot-icon {
  margin: 10px 0;
  width: 100%;
}

.icon-placeholder {
  width: 30px;
  height: 30px;
  margin-left: 10px;

}

.arrow-container {
  width: 100%;
  display: flex;
  justify-content: center;

  &.arrow-down {
    margin-top: 5px;
  }

  &.arrow-up {
    margin-bottom: 5px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}

.Chrome_arrow-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  padding-right: 44px;
}

.Chrome_arrow-up {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #fff;
  animation: bounce 1s infinite;
  animation-delay: 1.5s;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid #fff;
  animation: bounce 1s infinite;
  animation-delay: 2.5s;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #fff;
  animation: bounce 1s infinite;
  animation-delay: 1.5s;
  position: relative;
  right: 0;
}

@keyframes slideDown {
  0% {
    transform: translateY(-100%);
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  100% {
    transform: translateY(calc(100vh - 100% - 260px));
    animation-timing-function: ease-out;
  }
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  50% {
    transform: translateY(10px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
}

@keyframes slideToCorner {
  0% {
    transform: translate(-100%, -100%);
    animation-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
  }

  50% {
    transform: translate(-60%, -60%);
    animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  70% {
    transform: translate(-10%, -10%);
    animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  80% {
    transform: translate(-20%, -20%);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  90% {
    transform: translate(-15%, -15%);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  100% {
    transform: translate(-10%, -10%);
  }
}

@keyframes chromeSlideDown {
  0% {
    transform: translateY(-100%);
    animation-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
  }

  50% {
    transform: translateY(20px);
    animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  70% {
    transform: translateY(10px);
    animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  80% {
    transform: translateY(15px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  90% {
    transform: translateY(5px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  100% {
    transform: translateY(10px);
  }
}

@keyframes chromeSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 新增的印尼语提示弹框样式 */
.tips-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  z-index: 10000;
  animation: popIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
}

.tips-content {
  padding: 0;
}

.tips-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #4CAF50, #2E7D32);
  color: white;
  padding: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  h2 {
    color: white;
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .header-icon {
    font-size: 36px;
    margin-left: 10px;
  }
}

.tips-body {
  color: #333;
  font-size: 26px;
  line-height: 1.6;
  padding: 25px;

  p {
    margin-bottom: 25px;
    text-align: center;
  }
}

.method-container {
  margin: 15px 0;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.unfinished {
  flex: 1;
  background-color: #f5f5f5;
  color: #fff;
  border: none;
  border-radius: 30px;
  padding: 12px 25px;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
  height: 64px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #e0e0e0;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(1px);
  }
}

.completed {
  flex: 1;
  background: linear-gradient(to right, #4CAF50, #3d8b40);
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 25px;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
  height: 64px;
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);

  &:hover {
    background: linear-gradient(to right, #3d8b40, #2d682f);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(76, 175, 80, 0.4);
  }

  &:active {
    transform: translateY(1px);
  }
}

@keyframes popIn {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }

  70% {
    transform: translate(-50%, -50%) scale(1.05);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
</style>
